import React from "react";
import { Col } from "antd";
import { FormattedMessage } from "react-intl";
import Typography from "components/common/Typography";
import Table from "components/data/Table";
import ButtonLink from "components/common/ButtonLink";
import Header from "components/layout/Header";
import { ROUTE_PATHS } from "const/paths";

import { useOrganizationColumns, useOrganizationList } from "./hooks";

const Organizations = () => {
  const { loading, pagination, organizations, tableChangeHandler } =
    useOrganizationList();
  const { columns } = useOrganizationColumns();

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage defaultMessage="Organizations" />
          </Typography.Title>
        </Col>
        <Col>
          <ButtonLink type="primary" block to={ROUTE_PATHS.OrganizationCreate}>
            <FormattedMessage defaultMessage="Create new organization" />
          </ButtonLink>
        </Col>
      </Header>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={organizations}
        pagination={pagination}
        onChange={tableChangeHandler}
        loading={loading}
      />
    </>
  );
};

export default Organizations;
